import api from '../api/api'
import http from '../api/http'

const config = {
  baseURL: 'https://localhost:5001/v1'
}

export default {
  // getByEmail: async (params = {}) => {
  //   const response = await api.get(
  //     '/account/getUserByEmail', {
  //       config,
  //       params
  //     }
  //   );
  //   return response.data;
  // },
  
  
  
  // getByEmail: async (params = {}) => {
  //   const response = await http.get(
  //     '/account/getUserByEmail', {
  //       config,
  //       params
  //     }
  //   );
  //   debugger
  //   return response;
  // },




  login: async (body = {}) => {

    try {
      const response = await api.post(
        '/account/getUser',
        body, 
        config,
      )
      debugger
      const { data } = response;
      debugger
      if (data.Token) {
        return {
          token: data.Token
        }
      }

      return {
        error: 'Usuário e senha inválidos'
      }


    } catch (error) {
      return {
        error
      }
    }
  }
}